import { Link } from "react-router-dom"
import "./widget.css"

const Widget = ({
  type,
  noOfEnrolments,
  noOfPreEnrolments,
  noOfCourses,
  noOfBlogs,
}) => {
  let data
  switch (type) {
    case "enrolment":
      data = {
        title: "Enrolments",
        number: noOfEnrolments,
        link: <Link to="/enrol">See all enrolments</Link>,
        icon: (
          <i
            className="fas fa-users p-2"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
              borderRadius: "8px",
            }}
          ></i>
        ),
      }
      break
    case "pre-enrolment":
      data = {
        title: "Pre-Enrolments",
        number: noOfPreEnrolments,
        link: <Link to="/pre-enrolment">See all pre-enrolments</Link>,
        icon: (
          <i
            className="fas fa-users p-2"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
              borderRadius: "8px",
            }}
          ></i>
        ),
      }
      break
    case "course":
      data = {
        title: "Courses",
        link: <Link to="/course">See all courses</Link>,
        number: noOfCourses,
        icon: (
          <i
            className="fas fa-book p-2"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              borderRadius: "8px",
            }}
          ></i>
        ),
      }
      break
    case "blog":
      data = {
        title: "Blogs",
        link: <Link to="/blog">See all blogs</Link>,
        number: noOfBlogs,
        icon: (
          <i
            className="fas fa-blog p-2"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "purple",
              borderRadius: "8px",
            }}
          ></i>
        ),
      }
      break
    default:
      break
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">{data.number}</span>
        <span className="link">{data.link}</span>
      </div>
      <div className="right">
        <div className="percentage positive"></div>
        {data.icon}
      </div>
    </div>
  )
}

export default Widget
